import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Box from '@material-ui/core/Box';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Link from '@material-ui/core/Link';
import SharedUserDrawer, { DRAWER_WIDTH_LG, DRAWER_WIDTH_XL } from './SharedUserDrawer';
import logo5 from "../logo5.png"
import { PatientHeaderContent } from "../../Landingpagecomponents/Header/headerPatient";
import { useSelector, useDispatch } from "react-redux"
import { Button } from '@material-ui/core';
import * as AuthActions from "../../store/actions/auth";
import Auth from "../../Landingpagecomponents/Header/auth";
import { withRouter, useHistory } from "react-router-dom";
import PropTypes from 'prop-types';
import moment from 'moment';
import { Avatar, Card, CardActions, CardContent, Tabs, Tab } from '@material-ui/core';
import profileDetails from "./data/profileDetails";
import ProfileDetails from './data/profileDetails';
import Notifications from './data/notifications';
import PaymentSubscription from './data/paymentSubscription';
import Insurance from './data/insurance';
import HealingIcon from '@material-ui/icons/Healing';

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://material-ui.com/">
        Virtus Physio | Your Virtual Physiotherapist
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

// TabPanel component for managing tab content
function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box>
          {children}
        </Box>
      )}
    </div>
  );
}


const drawerWidth = 178;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  toolbar: {
    paddingRight: 24,
    minHeight: '50px !important',
    maxHeight: 50,
    [theme.breakpoints.up('xl')]: {
      minHeight: '57px !important',
      maxHeight: 57,
    },
  },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    height: 50,
    maxHeight: 50,
    boxShadow: '0 2px 4px rgba(40,40,40,0.22), 0 2px 6px rgba(40,40,40,0.28)',
    [theme.breakpoints.up('xl')]: {
      height: 57,
      maxHeight: 57,
    },
  },
  responsiveLogo: {
    marginTop: 2,
    maxWidth: 200,
    minWidth: 165,
    [theme.breakpoints.down('xs')]: {
      maxWidth: 120,
      minWidth: 165,
    },
    [theme.breakpoints.up('sm')]: {
      maxWidth: 200,
      minWidth: 165,
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: 200,
      minWidth: 165,
    },
    [theme.breakpoints.up('lg')]: {
      maxWidth: 250,
      minWidth: 165,
    },
    [theme.breakpoints.up('xl')]: {
      maxWidth: 250,
      minWidth: 165,
    },
  },
  appBarShift: {
    marginLeft: DRAWER_WIDTH_LG,
    width: `calc(100% - ${DRAWER_WIDTH_LG}px)`,
    [theme.breakpoints.up('xl')]: {
      marginLeft: DRAWER_WIDTH_XL,
      width: `calc(100% - ${DRAWER_WIDTH_XL}px)`,
    },
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginRight: 0,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  container: {
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  containerEmbedded: {
    paddingTop: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  fixedHeight: {
    height: 'auto',
  },
  headline: {
    color: '#002D55',
    fontSize: 'clamp(1rem, 1.2vw, 1.6rem)',
  },
  subheadline: {
    color: '#324158',
    fontSize: 'clamp(0.75rem, 0.9vw, 1.12rem)',
  },
  tabsRoot: {
    backgroundColor: '#f7faff',
    borderRadius: 12,
    marginBottom: theme.spacing(1),
    height: 'clamp(34px, calc(4px + 4.5vw), 44px)',
    overflow: 'hidden',
    boxShadow: '0 4px 16px rgba(0,45,85,0.12)',
  },
  tabsControlRoot: {
    minHeight: 'clamp(34px, calc(4px + 4.5vw), 44px)',
    height: 'clamp(34px, calc(4px + 4.5vw), 44px)',
    '& .MuiTabs-flexContainer': {
      height: '100%',
      alignItems: 'center',
    },
  },
  tabRoot: {
    fontWeight: 600,
    fontSize: 'clamp(0.75rem, 1.04vw, 0.95rem)',
    textTransform: 'none',
    color: '#002D55',
    minHeight: 'clamp(24px, calc(4px + 4.5vw), 34px)',
    height: 'clamp(24px, calc(4px + 4.5vw), 34px)',
    minWidth: 'clamp(60px, 6.9vw, 100px)',
    padding: '0 clamp(4px, 0.7vw, 12px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    '&.Mui-selected': {
      color: '#002D55',
    },
    '&:hover': {
      color: '#FF7F27',
    },
  },
}));

export default function Myaccount() {
  const [isLoggedIn, setIsLoggedIn] = useState(useSelector(state => state.auth.isLoggedIn))
  const token = useSelector(state => state.auth.token);
  const embeddedWorkspace = typeof window !== 'undefined'
    && new URLSearchParams(window.location.search).get('embedded') === '1';
  const history = useHistory();
  const searchParams = new URLSearchParams(window.location.search);
  const shouldPromptAutopay = ['1', 'true', 'yes'].includes(
    String(searchParams.get('autopay_request') || '').toLowerCase()
  );
  const [activeTab, setActiveTab] = useState(() => {
    const tab = searchParams.get('tab');
    if (tab === 'profile') return 2;
    if (tab === 'insurance') return 1;
    if (tab === 'payment') return 0;
    return 0;
  });

  const dispatch = useDispatch();

  const handleClickLogout = () => {
    dispatch({ type: AuthActions.LOGOUT });
    window.location.replace("/");
  };

  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const handleDrawerOpen = () => setOpen(true);
  const handleDrawerClose = () => setOpen(false);
  const handleProfileClick = () => {
    setActiveTab(2);
    history.replace('/myaccount?tab=profile');
  };

 // const user = {
 //   avatar: '/static/images/avatars/avatar_6.png',
 //   city: 'Los Angeles',
 //   country: 'USA',
 //   jobTitle: 'Senior Developer',
 //   name: 'Katarina Smith',
 //   timezone: 'GTM-7'
 // };


  const Profile = ({ className, ...rest }) => {
    const classes = useStyles();

    return (
      <Card
      className={classes.root}
      >
      
    </Card>
    );
  };

  Profile.propTypes = {
    className: PropTypes.string
  };

  const fixedHeightPaper = clsx(classes.paper, classes.fixedHeight);
  
  // Security check: verify authentication before rendering
  if (!isLoggedIn || !token) {
    window.location.replace("/");
    return <div>Redirecting...</div>;
  }
  
  if (isLoggedIn) {
    return (
      <div className={classes.root}>
        <CssBaseline />
        {!embeddedWorkspace ? (
          <>
            <AppBar style={{ color: "#002D55", background: '#FFFF' }} position="absolute" className={clsx(classes.appBar, open && classes.appBarShift)}>
              <Toolbar className={classes.toolbar}>
                <PatientHeaderContent onLogout={handleClickLogout} onProfile={handleProfileClick} onOpenVideo={() => {}} onOpenCheckin={() => {}} />
              </Toolbar>
            </AppBar>
            <SharedUserDrawer open={open} onOpen={handleDrawerOpen} onClose={handleDrawerClose} />
          </>
        ) : null}
        <main className={classes.content} style={{background: 'linear-gradient(90deg, #dce4eb, #d7d4cf)'}}>
          {!embeddedWorkspace ? <div className={classes.appBarSpacer} /> : null}
          <Grid maxWidth="lg" className={clsx(classes.container, embeddedWorkspace && classes.containerEmbedded)} style={{ marginTop: 0, marginRight: 0, marginLeft: 0}}>
            <Grid item xs={12} >
              <Box>
                <div className={classes.tabsRoot}>
                <Tabs 
                  value={activeTab} 
                  onChange={(event, newValue) => setActiveTab(newValue)}
                  TabIndicatorProps={{ style: { backgroundColor: '#FF7F27', height: 3, borderRadius: 18 } }}
                  textColor="inherit"
                  classes={{ root: classes.tabsControlRoot }}
                >
                  <Tab 
                    label="Payment & Subscription" 
                    id="tab-0"
                    aria-controls="tabpanel-0"
                    classes={{ root: classes.tabRoot }}
                  />
                  <Tab 
                    label="Insurance" 
                    id="tab-1"
                    aria-controls="tabpanel-1"
                    classes={{ root: classes.tabRoot }}
                  />
                  <Tab 
                    label="Profile" 
                    id="tab-2"
                    aria-controls="tabpanel-2"
                    classes={{ root: classes.tabRoot }}
                  />
                </Tabs>
                </div>
                
                <TabPanel value={activeTab} index={0}>
                  <PaymentSubscription
                    style={{marginTop: "0%"}}
                    promptAutoPayRequest={shouldPromptAutopay}
                  />
                </TabPanel>
                
                <TabPanel value={activeTab} index={1}>
                  <Insurance style={{marginTop: "0%"}} />
                </TabPanel>
                
                <TabPanel value={activeTab} index={2}>
                  <ProfileDetails style={{marginTop: "0%", marginBottom: 20}} />
                  <Notifications />
                </TabPanel>
              </Box>
            </Grid>
            
            <Box pt={4}>
              <Copyright />
            </Box>
          </Grid>
        </main>
      </div>
    );
  } else {
    return <div>Unauthorized</div>;
  }
}
